<template>
  <div class="abTeamPer_row" v-if="rowData">
    <span class="row_title" v-text="rowData.text"></span>
    <span class="row_perArea">
      <span
        class="perArea_leftVal"
        v-text="`${rowData.homeValue}${rowData.suffix}`"
      ></span>
      <span class="perArea_perBg">
        <span
          class="perArea_left"
          :style="{ width: `${rowData.homePer}%` }"
        ></span>
        <span
          class="perArea_right"
          :style="{ width: `${rowData.awayPer}%` }"
        ></span>
      </span>
      <span
        class="perArea_rightVal"
        v-text="`${rowData.awayValue}${rowData.suffix}`"
      ></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'abTeamPer',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return null
        //   {
        //   maxValue: '',
        //   homeValue: '',
        //   awayValue: '',
        //   text: '',
        //   suffix: '',
        //   homePer: 0,
        //   awayPer: 0,
        // }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.abTeamPer_row {
  display: block;
  width: 100%;
  color: var(--mixtmt_greyColor3);
  .row_title {
    display: block;
    font-size: 0.833vw;
    line-height: 1.25vw;
    text-align: center;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .row_perArea {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 0.833vw;
    height: 0.972vw;
    .perArea_leftVal,
    .perArea_rightVal {
      width: 2.583vw;
    }
    .perArea_leftVal {
      text-align: right;
      padding-right: 0.278vw;
    }
    .perArea_rightVal {
      padding-left: 0.278vw;
    }
    .perArea_perBg {
      position: relative;
      width: calc(100% - 5.166vw);
      height: 0.694vw;
      background-color: var(--mixtmt_greyColor8);
      .perArea_left,
      .perArea_right {
        position: absolute;
        top: 0;
        width: 0;
        height: 100%;
      }
      .perArea_left {
        left: 0;
        background-color: var(--mixtmt_combatBar1_1);
      }
      .perArea_right {
        right: 0;
        background-color: var(--mixtmt_combatBar1_2);
      }
    }
  }
}
</style>
